import { useEffect, useState } from 'react'
import { TablePagination } from '../../../../../components/table'
import { useRESTapi } from '../../../../../hooks/rest_API'
import { Carousel, ProductCategory, CarouselKeys, pagination, } from '../../../../../types'
import { AddCategoryModal } from './component/addmodal'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/src/components/ui/table'
import { ButtonIcon } from '@/src/components/buttons/buttonIcon'
import { Pencil, Trash } from 'lucide-react'
import { Button } from '@/src/components/ui/button'
import { useAlertModal } from '@/src/hooks/alert_modal'
import { SkeletonTableAdmin } from '../../../components/skeltonTable'
import { DeleteModal } from './component/deleteModal'
import { Input } from '@/src/components/ui/input'
import { Label } from '@/src/components/ui/label'

interface CarouselList extends Carousel {
  delete: any,
  edit: any,
  image: any,
  page_number: number
}

type Props = {
  setSelectedId: (id: string) => any
}

export function CommonPage(props: Props) {


  const api = useRESTapi()
  const [update, setUpdate] = useState(false)
  const alertModal = useAlertModal()
  const [isProductLoading, setisProductLoading] = useState(false)
  const [savingMargin, setsavingMargin] = useState(false)


  const [configuration, setConfiguration] = useState<{
    margin: number,
    margin24k:number,
    margin24kproducts:number,
    delivery_charge: number,
    margin24ksell:number
  }>({
    margin: 0,
    margin24k:0,
    margin24kproducts:0,
    delivery_charge: 0,
    margin24ksell:0
  })

  const saveData = async () => {
    setsavingMargin(true)
    try {
      const res = await api.put<{ success: boolean, message: string }>({
        url: `${process.env.REACT_APP_BACKEND_URL_ADMIN!}/configurations`,
        body: {
          M29_margin: configuration.margin||0,
          M29_margin_products: configuration.margin24kproducts||0,
          M29_margin_24k: configuration.margin24k||0,
          M29_delivery_charge: configuration.delivery_charge||0,
          M29_margin_sell_24k: configuration.margin24ksell||0
        },
        mode: 'admin',

      })

      if (res.data.success === true) {
        alertModal.open_alert_modal({
          content: res.data.message,
          footer: <Button onClick={alertModal.close_alert_modal}>Ok</Button>,
          title: 'Success'
        })
      } else {
        alertModal.open_alert_modal({
          content: res.data.message,
          footer: <Button onClick={alertModal.close_alert_modal}>Ok</Button>,
          title: 'Error'
        })
      }
    } catch (error) {
      console.log(error)
      alertModal.open_alert_modal({
        content: 'Server Error',
        footer: <Button onClick={alertModal.close_alert_modal}>Ok</Button>,
        title: 'Error'
      })
    }

    setsavingMargin(false)
  }



  useEffect(
    () => {
      props.setSelectedId('D1')
      const initData = async () => {
        setisProductLoading(true)

        try {
          const res = await api.get<{ success: boolean, message: string, data: {
             margin: number,
             margin24k:number,
             marginProduct24k:number,
             delveryCharge: number,
             margin24ksell:number
             } & pagination }>({
            url: `${process.env.REACT_APP_BACKEND_URL_ADMIN!}/configurations`,
            mode: 'admin',

          })

          if (res.data.success === true) {
            console.log(res.data)
            setConfiguration({
              margin: res.data.data.margin||0,
              margin24k:res.data.data.margin24k||0,
              margin24kproducts:res.data.data.marginProduct24k||0 ,
              delivery_charge: res.data.data.delveryCharge||0,
              margin24ksell:res.data.data.margin24ksell||0
            })
            setisProductLoading(false)
            // set_products_total(res.data.data.total)
          } else {
            alertModal.open_alert_modal({
              content: res.data.message,
              footer: <Button onClick={alertModal.close_alert_modal}>Ok</Button>,
              title: 'Error'
            })
          }
        } catch (error) {
          console.log(error)
          alertModal.open_alert_modal({
            content: 'Server Error',
            footer: <Button onClick={alertModal.close_alert_modal}>Ok</Button>,
            title: 'Error'
          })
        }

      }



      initData()

    }, [update]
  )

  return (
    <div className='  grow flex flex-col items-center  overflow-hidden py-5 gap-2 px-1 sm:px-5 '>
      <div className=' w-full flex flex-col gap-2'>

        <Label>Gold rate margin</Label>
        <div className=' flex gap-3 w-min '>
          <Input
            value={configuration.margin}
            title='Margin' type='number'
            placeholder='margin' className=' min-w-44'
            onChange={(e) => {
              setConfiguration({
                ...configuration,
                margin: e.target.value?Number(e.target.value):NaN
              })
            }}
            disabled={isProductLoading}
          />
          <Button onClick={saveData} disabled={savingMargin} >
            {savingMargin ? 'Saving...' : 'Save'}
          </Button>
        </div>
        <Label>Gold rate margin 24k</Label>
        <div className=' flex gap-3 w-min '>
          <Input
            value={configuration.margin24k}
            title='Margin' type='number'
            placeholder='margin 24k' className=' min-w-44'
            onChange={(e) => {
              setConfiguration({
                ...configuration,
                margin24k: e.target.value?Number(e.target.value):NaN
              })
            }}
            disabled={isProductLoading}
          />
          <Button onClick={saveData} disabled={savingMargin} >
            {savingMargin ? 'Saving...' : 'Save'}
          </Button>
        </div>
        <Label>Gold rate sell margin 24k</Label>
        <div className=' flex gap-3 w-min '>
          <Input
            value={configuration.margin24ksell}
            title='Margin' type='number'
            placeholder='margin 24k' className=' min-w-44'
            onChange={(e) => {
              setConfiguration({
                ...configuration,
                margin24ksell: e.target.value?Number(e.target.value):NaN
              })
            }}
            disabled={isProductLoading}
          />
          <Button onClick={saveData} disabled={savingMargin} >
            {savingMargin ? 'Saving...' : 'Save'}
          </Button>
        </div>
        <Label>Gold rate margin product 24k</Label>
        <div className=' flex gap-3 w-min '>
          <Input
            value={configuration.margin24kproducts}
            title='Margin' type='number'
            placeholder='margin product 24k' className=' min-w-44'
            onChange={(e) => {
              setConfiguration({
                ...configuration,
                margin24kproducts: e.target.value?Number(e.target.value):NaN
              })
            }}
            disabled={isProductLoading}
          />
          <Button onClick={saveData} disabled={savingMargin} >
            {savingMargin ? 'Saving...' : 'Save'}
          </Button>
        </div>
        <Label>Delivery Charge</Label>
        <div className=' flex gap-3 w-min '>
          <Input
            value={configuration.delivery_charge}
            title='Margin' type='number'
            placeholder='margin product 24k' className=' min-w-44'
            onChange={(e) => {
              setConfiguration({
                ...configuration,
                delivery_charge: e.target.value?Number(e.target.value):NaN
              })
            }}
            disabled={isProductLoading}
          />
          <Button onClick={saveData} disabled={savingMargin} >
            {savingMargin ? 'Saving...' : 'Save'}
          </Button>
        </div>
      </div>
    </div>
  )
}
